// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2jAfP","footer":"ModalInfo_footer__2Y98u"};